import { Component, OnInit, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NavService } from '@ukam/shell/services/nav.service';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-horizontal-nav-item',
    imports: [CommonModule, MatIconModule],
    templateUrl: './nav-item.component.html'
})
export class AppHorizontalNavItemComponent implements OnInit {
  navService = inject(NavService);
  router = inject(Router);

  @Input() depth: any;
  @Input() item: any;

  constructor() {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  ngOnInit() { }
  onItemSelected(item: any) {
    if (!item.children || !item.children.length) {
      this.router.navigate([item.route]);
    }
  }
}
